module.exports = __webpack_public_path__ + "img/qrcode.b5af5e83.png";